import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';
import { StyleSheet, css } from 'aphrodite';

import { images } from '../../constants';

const galleryImages = [images.meal14, images.gallery6, images.meal24, images.gallery11, images.meal35, images.gallery17];

const Gallery = () => {
  const scrollRef = React.useRef(null);
  const scroll = (direction) => {
    scrollRef.current?.scrollBy({ left: direction === 'left' ? -340 : 340, behavior: 'smooth' });
  };

  return (
    <section className={css(styles.gallery)} aria-labelledby="gallery-heading">
      <div className={css(styles.headingRow)}>
        <div>
          <p className={css(styles.eyebrow)}>A taste of Fortress</p>
          <h2 id="gallery-heading" className={css(styles.title)}>This is what<br /><em>delicious looks like.</em></h2>
        </div>
        <div className={css(styles.sideCopy)}>
          <p>Plates with presence, rooms with warmth, and evenings made to be shared.</p>
          <Link to="/gallery" className={css(styles.link)}>View the full gallery ↗</Link>
        </div>
      </div>

      <div className={css(styles.scroller)} ref={scrollRef}>
        {galleryImages.map((image, index) => (
          <figure key={image} className={css(styles.figure, index % 3 === 1 && styles.tallFigure)}>
            <img src={image} alt={`Fortress food and atmosphere ${index + 1}`} className={css(styles.image)} loading="lazy" />
          </figure>
        ))}
      </div>

      <div className={css(styles.controls)}>
        <span>Swipe to explore</span>
        <div>
          <button onClick={() => scroll('left')} aria-label="Previous gallery image"><BsArrowLeftShort /></button>
          <button onClick={() => scroll('right')} aria-label="Next gallery image"><BsArrowRightShort /></button>
        </div>
      </div>
    </section>
  );
};

const styles = StyleSheet.create({
  gallery: { background: 'var(--color-paper)', padding: 'clamp(5rem,10vw,9rem) 0' },
  headingRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'end', gap: '3rem', padding: '0 clamp(1.5rem,6vw,6.5rem)', marginBottom: '3.5rem', '@media (max-width:760px)': { flexDirection: 'column', alignItems: 'flex-start', gap: '1.5rem' } },
  eyebrow: { fontFamily: 'var(--font-ui)', color: 'var(--color-golden)', fontSize: '.72rem', fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', marginBottom: '1.2rem' },
  title: { fontFamily: 'var(--font-base)', color: 'var(--color-green)', fontSize: 'clamp(2.8rem,5vw,5.2rem)', lineHeight: 1.05, fontWeight: 500, letterSpacing: '-.035em' },
  sideCopy: { maxWidth: '360px', color: 'var(--color-gray)', fontSize: '.95rem', lineHeight: 1.7 },
  link: { display: 'inline-block', marginTop: '1.2rem', color: 'var(--color-green)', fontFamily: 'var(--font-ui)', fontSize: '.7rem', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', borderBottom: '1px solid rgba(35,79,64,.3)', paddingBottom: '.25rem' },
  scroller: { display: 'flex', alignItems: 'center', gap: '1.2rem', overflowX: 'auto', scrollSnapType: 'x mandatory', scrollbarWidth: 'none', padding: '0 clamp(1.5rem,6vw,6.5rem)', '::-webkit-scrollbar': { display: 'none' } },
  figure: { flex: '0 0 clamp(260px,30vw,430px)', height: '430px', scrollSnapAlign: 'start', overflow: 'hidden', borderRadius: '18px' },
  tallFigure: { height: '510px', '@media (max-width:650px)': { height: '430px' } },
  image: { width: '100%', height: '100%', objectFit: 'cover', transition: 'transform .6s ease', ':hover': { transform: 'scale(1.035)' } },
  controls: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem clamp(1.5rem,6vw,6.5rem) 0', color: 'var(--color-gray)', fontFamily: 'var(--font-ui)', fontSize: '.67rem', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', '> div': { display: 'flex', gap: '.5rem' }, '> div > button': { width: '44px', height: '44px', display: 'grid', placeItems: 'center', borderRadius: '50%', border: '1px solid rgba(35,79,64,.2)', background: 'transparent', color: 'var(--color-green)', fontSize: '1.4rem', cursor: 'pointer' } },
});

export default Gallery;
